//dependencias
import React, { Component } from 'react';

//componentes
import ConsultaIT3Action from './consultaIT3'

class Index extends Component {

    render(){
        return(
            <div>
                <ConsultaIT3Action />
            </div>
        );
    }

}
export default Index;